
import { mapGetters } from 'vuex';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    mixins: [HeaderNavigationMixin],
    data() {
        return {
            isShow: false,
            userTheme: 'light-theme'
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isNovaPorta: 'global/getIsNovaPorta',
            isUniPlast: 'global/getIsUniPlast',
            mainPhoneNumber: 'global/mainPhoneNumber',
            getMainTheme: 'global/getMainTheme',
            getCurrentTheme: 'global/getCurrentTheme'
        }),
        currentLocaleName() {
            return this.$i18n.locales?.filter(i => i?.code === this.$i18n.locale)[0]?.code;
        },
        themeText() {
            return this.userTheme === 'light-theme' ? this.$t('themeDark') : this.$t('themeLight');
        },
        isClient() {
            return process.client;
        }
    },
    methods: {
        closeLangMenu() {
            this.isShow = false;
        },
        forceRepaint() {
            document.body.style.display = 'none';
            document.body.offsetHeight;
            document.body.style.display = '';
        },
        setTheme(name) {
            this.userTheme = name;

            if (name === 'light-theme') {
                document.body.classList.remove('dark-theme');
                document.body.classList.add('light-theme');
                this.$cookies.set('user-theme', 'light-theme');
                this.$store.dispatch('global/setTheme', 'light-theme');
            } else if (name === 'dark-theme') {
                document.body.classList.remove('light-theme');
                document.body.classList.add('dark-theme');
                this.$cookies.set('user-theme', 'dark-theme');
                this.$store.dispatch('global/setTheme', 'dark-theme');
            }

            this.forceRepaint();
        },
        getTheme() {
            const savedTheme = this.$cookies.get('user-theme');

            const isDarkTheme = document.body.classList.contains('dark-theme');

            if (savedTheme) {
                return savedTheme;
            } else {
                if (isDarkTheme) {
                    return 'dark-theme';
                }
                return 'light-theme';
            }
        },
        toggleTheme() {
            const activeTheme = this.getTheme(); //localStorage?.getItem('user-theme');
            if (activeTheme === 'light-theme') {
                this.setTheme('dark-theme');
            } else {
                this.setTheme('light-theme');
            }
        },
        setActiveClass(path) {
            // Вспомогательная функция для получения последнего непустого сегмента URL
            const getLastSegment = fullPath => {
                const segments = fullPath.split('/').filter(segment => segment.length > 0);
                return segments[segments.length - 1] || '';
            };

            const currentSegment = getLastSegment(this.$route.path);
            const linkSegment = getLastSegment(path);

            // Если требуется точное совпадение:
            // return currentSegment === linkSegment ? 'active' : '';

            // Если требуется, чтобы активным считался элемент, если последний сегмент маршрута содержит ссылочный сегмент:
            return currentSegment.includes(linkSegment) ? 'active' : '';
        }
    },
    mounted() {
        const initUserTheme = this.getTheme() || this.getMainTheme?.replace(/_/, '-');
        this.setTheme(initUserTheme);
    }
};
